.ux-iws-nb-product-header {
    display: block;
    position: relative;

    &__header {
        display: block;
        padding: 0;
        margin: 0;

        @media (min-width: 1024px) {
            padding-left: calc(100% / 12);
            padding-right: calc(100% / 12);
        }
    }

    &__box {
        box-sizing: border-box;
        padding: 30px 15px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        background-color: #fff;
        width: 100%;

        @media (max-width: 567px) {
            align-items: stretch;
        }

        @media (min-width: 568px) {
            padding: 30px;
        }

        @media (min-width: 768px) {
            padding: 30px 30px 60px;
            flex-flow: row nowrap;
            gap: 80px;
            align-items: flex-end;
            justify-content: space-between;
        }

        @media (min-width: 1024px) {
            padding: 30px 0 60px;
        }

        @media (min-width: 1440px) {
            position: absolute;
            padding: 30px;
            left: 30px;
            bottom: 30px;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: calc(100% * 4 / 12 - 30px);
            gap: 0;
        }
    }

    &__text {
        max-width: 600px;
    }

    &__cta {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-end;
        margin-top: 30px;
    }

    h1,
    h2 {
        @include nb-heading(1, false);
        margin-bottom: 10px;

        @media (min-width: 1440px) {
            margin-bottom: 30px;
        }
    }

    p {
        @include nb-text(large);
        margin: 0;

        &:not(:last-of-type) {
            margin-bottom: 10px;
        }
    }

    @media (max-width: 567px) {
        ux-button {
            width: 100%;
        }
    }

    ux-iws-nb-image-zoom {
        --aspect-ratio-mobile: 3 / 2;
        --aspect-ratio-desktop: 3 / 1;
    }
}
